import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { QuestionCircleFilled } from "@fluentui/react-icons";

export default function HelpPage() {
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            updateDocumentTitle( "Help & Support | Contents" );
            navData.sidebarSelectedNavValue = "help";
            navData.subPageNavValue = null;
            setNavData({...navData});
        },
        []
    );

    return (
        <>
            <SubPageTitle icon={<QuestionCircleFilled />} title="Help &amp; Support" subTitle="Contents" />
        </>
    );
}